// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1__9U","cls2":"ProfilePdfPackCard-cls2__zY ProfilePdfPackCard-cls1__9U"};